<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <h6 *ngIf="code" class="modal-title" i18n>Edit Custom Code</h6>
        <h6 *ngIf="!code" class="modal-title" i18n>New Custom Code</h6>
        <div class="flex-fill"></div>
        <button *ngIf="code" (click)="onRemove()" type="button" class="btn btn-secondary-danger">
          <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>delete</ng-container>
        </button>
        <button *ngIf="code" (click)="onManageTags()" type="button" class="btn btn-secondary-primary">
          <i class="far fa-plus"></i> <ng-container i18n>tags</ng-container>
        </button>
        <button (click)="save(form)" type="button" class="btn btn-secondary-info">
          <i class="cs-icon cs-icon-save"></i> <ng-container i18n>save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close" aria-label="Close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <!-- /.modal-header -->
    <div class="modal-body">
      <alert *ngIf="isExisting$ | async" type="danger">
        <span *ngIf="form.get('rentals').value.length === 0" i18n>Code name is already in use</span>
        <span *ngIf="form.get('rentals').value.length > 0" i18n
          >Code name is already in use for particular rentals</span
        >
      </alert>
      <div class="container-box">
        <form [formGroup]="form">
          <div class="p-3">
            <div class="row">
              <div class="col-md-4">
                <mat-form-field2 class="mat-block">
                  <input
                    matInput
                    required
                    placeholder="Name"
                    formControlName="name"
                    type="text"
                    maxlength="{{ nameMaxLength }}"
                    i18n-matTooltip
                    i18n-placeholder
                    matTooltip="Enter a name for this code. It can only contain letters and numbers. Multiple codes can use the same name, but they can not be assigned to the same rentals."
                    matTooltipPosition="above"
                  />
                  <mat-hint align="end">{{ form.get('name').value?.length || 0 }}/{{ nameMaxLength }}</mat-hint>
                  <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
                    <ng-container i18n>Custom Code Name is required</ng-container>
                  </mat-error>
                  <mat-error *ngIf="form.get('name').hasError('alphaNum')">
                    <ng-container i18n>Name must only contain alphanumeric characters and no spaces</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-4">
                <mat-form-field2 class="mat-block">
                  <input
                    matInput
                    i18n-placeholder
                    placeholder="Description"
                    formControlName="description"
                    type="text"
                    maxlength="{{ descMaxLength }}"
                    i18n-matTooltip
                    matTooltip="Enter a description for this code. This description will allow you to quickly identify the purpose of this data dictionary code."
                    matTooltipPosition="above"
                  />
                  <mat-hint align="end">{{ form.get('description').value?.length || 0 }}/{{ descMaxLength }}</mat-hint>
                  <mat-error *ngIf="form.get('description').hasError('maxlength')">
                    <ng-container i18n>Description must be at most 140 characters</ng-container>
                  </mat-error>
                </mat-form-field2>
              </div>
              <div class="col-md-4">
                <app-rental-select
                  i18n-matTooltip
                  matTooltip="Click here to select the rentals for which this code will be used. When a template is sent to a guest in this rental, the contents of this code will be inserted into the template."
                  matTooltipPosition="above"
                  [ctrl]="form.get('rentals')"
                  i18n-placeholder
                  placeholder="Rentals"
                ></app-rental-select>
              </div>
            </div>
          </div>
          <app-tiny-mce-editor
            #tinyMceEditor
            [maxHeight]="700"
            [minHeight]="500"
            [ctrl]="form.get('body')"
          ></app-tiny-mce-editor>
          <mat-error *ngIf="form.get('body').touched && form.get('body').hasError('required')" class="ml5">
            <ng-container i18n>Body is required</ng-container>
          </mat-error>
        </form>
      </div>
    </div>
  </div>
</div>
